
import LandingPage from "./pages/user"
import { RequireAuth } from "./context/auth-context"
import Userlayout from "./layouts/user-layout"
import { Children } from "react"
import AdminLayout from "./layouts/admin-layout"
import Settings from "./pages/admin/settings"
import Dashboard from "./pages/admin"
import Users from "./pages/admin/users"
import Input from "./pages/admin/input"
import Budget from "./pages/admin/budget"
import Bills from "./pages/user/bills/bills"
import CashbookPage from "./pages/user/cashbook/cashbook"
import CustomerPage from "./pages/user/customers/customer"
import SupplierManagement from "./pages/user/suppliers/suppliers"
import Reports from "./pages/user/reports"
import Dashboards from "./pages/user/dashboard"
import Journal from "./pages/user/journal"
import Transactions from "./pages/user/cashbook/trans"
import Recon from "./pages/user/recon"
import Loans from "./pages/user/loans"
import Opening from "./pages/admin/opening"
import ProjectPage from "./pages/user/projects"
import Audit from "./pages/admin/audit"
import Mobile from "./layouts/mobile"
import PhoneLayout from "./layouts/mobile"
import Clients from "./pages/user/clients"
import Revenue from "./layouts/revenue"
import RevenueDashboard from "./pages/revenue/Dashboard"
import Land from "./pages/revenue/Land"
import Properties from "./pages/revenue/Properties"
import Shops from "./pages/revenue/Shops"
import LandManagement from "./pages/LandManagement"
const routes = [
    {
        path: "/",
        element: <RequireAuth><Userlayout /></RequireAuth>,
        children:[
            {
                path: "/",
                element: <Dashboards />,
            },
            {   
                path: "/budget",
                element: <LandingPage />,
            },
            {
                path: "/bills",
                element: <Bills />,
            },
            {
                path: "/cashbook",
                element: <CashbookPage />,
            },
            {
                path: "/customers",
                element: <CustomerPage />,
            },
            {
                path: "/suppliers",
                element: <SupplierManagement />,
            },
            {
                path: "/loans",
                element: <Loans />,
            },
            {
                path: "/reports",
                element: <Reports />,
            },
            {
                path: "/journal",
                element: <Journal />,
            },
            {
                path: "/transactions",
                element: <Transactions />,
            },
            {
                path: "/projects",
                element: <ProjectPage />,
            },
            {
                path: "/recon",
                element: <Recon />,
            }, {
                path: "/clients",
                element: <Clients />,
            },
            {
                path: "/audit",
                element: <Audit />,
            },
            
        ]
    },
    {
        path: "/mobile",
        element: <RequireAuth><PhoneLayout /></RequireAuth>,
        children:[
            {
                path: "/mobile",
                element: <Dashboards />,
            },
        ]
    },
    {
        path: "/revenue",
        element: <RequireAuth><Revenue /></RequireAuth>,
        children:[
            {
                path: "/revenue",
                element: <RevenueDashboard />,
            },
            {
                path: "/revenue/bills",
                element: <Bills />,
            },
            {
                path: "/revenue/reports",
                element: <Reports />,
            },
            {
                path: "/revenue/customers",
                element: <CustomerPage />,
            },
            {
                path: "/revenue/clients",
                element: <Clients />,
            },
            {
                path: "/revenue/properties",
                element: <Properties />,
            },
            {
                path: "/revenue/land",  
                element: <Land />,
            },
            {
                path: "/revenue/land-management",
                element: <LandManagement />,
            },
            {
                path: "/revenue/shops",
                element: <Shops />,
            },
            
                            
        ]
    },
    {
        path: "/admin",
        element: <RequireAuth><AdminLayout /></RequireAuth>,
        children:[
            {
                path: "/admin",
                element: <Dashboard />,
            },
            {
                path: "/admin/settings",
                element: <Settings />,
            },
            {
                path: "/admin/users",
                element: <Users />,
            },
            {
                path: "/admin/input",
                element: <Input />,
            },
            {
                path: "/admin/budget",
                element: <Budget />,
            },
            {
                path: "/admin/opening",
                element: <Opening />,
            },
            
        ]
    },
]

export default routes